import React from 'react'
import classNames from 'classnames'
import fbLogo from '../../../public/images/icons/facebook.svg'
import igLogo from '../../../public/images/icons/insta.svg'
import twLogo from '../../../public/images/icons/twitter.svg'

const AboutBanner = ({ active, selectedMember }) => {
  const { description, name, role, social, website } = selectedMember

  const bannerClassNames = classNames({
    'about-banner': true
  })
    
  return (
    <div className={bannerClassNames}>
     <div className="about-content">
       <h3>{name}</h3>
       <h4>{role}</h4>
       <p>{description}</p>
       { website &&
          <a className="link" href={website} target="_blank">{website}</a>
       }
       { social &&
         <div className="social">
           { social.facebook &&
             <a href={`https://facebook.com/${social.facebook}`} target="_blank">
                <img src={fbLogo} alt="facebook" />
              </a>
           }
           { social.instagram &&
              <a href={`https://instagram.com/${social.instagram}`} target="_blank">
                <img src={igLogo} alt="instagram" />
              </a>
           }
           { social.twitter &&
              <a href={`https://twitter.com/${social.twitter}`} target="_blank">
                <img src={twLogo} alt="twitter" />
              </a>
           }
         </div>
       }
     </div>
    </div>
  )
}

export default AboutBanner


// WEBPACK FOOTER //
// ./src/components/About/AboutBanner.js